/** API routes for employer B2B job opportunities — registered in ~/utils/routes.ts. */

export const B2B_JOB_OPPORTUNITIES_ROUTES = {
  get: '/hlx/job-responses/b2b-opportunities',
};

export const B2B_LISTING_RESPONSES_ROUTES = {
  get: '/hlx/job-responses/b2b-listing-responses',
};

export const JOB_RESPONSE_PROVIDERS_ROUTES = {
  get: '/hlx/job-responses/{responseId}/providers',
  put: '/hlx/job-responses/{responseId}/providers',
};

export const HLX_PICKER_PROVIDERS_ROUTES = {
  get: '/hlx/employers/{employerId}/picker-providers',
};
